<template>
  <div>
    <cleave
        @input="
        (val) => {
          inputField(val);
        }
      "
        :options="{
        // date: true,
        delimiter: '/',
        // datePattern: ['Y', 'm','D'],
        raw: false,
        blocks: [4, 2, 2],
      }"
        class="form-control"
        name="card"
        :raw="false"
        :value="value"
        :disabled="disabled"
        :key="value"
    />
  </div>
</template>

<script>
import dateFormat from "@/mixins/dateFormat";
import Cleave from "vue-cleave-component";

export default {
  data() {
    return {
      //   newValue: null,
    };
  },
  props: {
    value: {
      default: null,
    },
    disabled: {
      default: false,
    },
    isForeigner: {
      default: false,
    },
  },
  methods: {
    inputField(val) {
     if (!!val  && val.length === 10) {

        if (!!this.fromCleaveDateConvert(val, this.isForeigner)) {
          this.$emit("updateDate", val);
          // this.value = this.fromCleaveDateConvert(val, this.isForeigner)
          this.$emit("error", false);
        } else {
          // if (!val) {
          //   this.$emit("input", val);
          //   this.$emit("error", false);
          // } else {
            //  this.newValue = ''
            this.$emit("error", true);
          // }
          //  this.$emit('input', val)
        }
      }else{

       if (!val){
         this.$emit("updateDate", val);
         this.$emit("error", false);
       }else{
         this.$emit("error", true);
       }
     }
    },
  },
  mixins: [dateFormat],
  computed: {
    // newValue: {
    //   set(val) {
    //     // this.newValue = val;
    //   },
    //   get() {
    //     if (this.value) {
    //       // return this.toCleaveDateConvert(this.value);
    //       return this.value;
    //     } else {
    //       return "";
    //     }
    //   },
    // },
  },
  watch: {
    value: {
      deep: true,
      handler() {
        if (!this.value) {

          this.inputField(this.value);
        }
      },
    },
  },
  components: { Cleave },
};
</script>
